import Vue from 'vue';
import Vuex from 'vuex';
import getProductType from '../classes/find_family';
import getDocument from '../classes/get_document';
import new_product_link_search from '../classes/new_product_link_search';
import change_img from '../classes/class_change_img';
import filter_array from '../classes/class_filter_arrays';
import sorgenti_s from '../classes/class_sorgenti';
import checkLanguage from "../classes/class_check_language";
import is_localhost from "../classes/class_is_localhost";
import cart from "../classes/cart_number";

Vue.use(Vuex);

export const store = new Vuex.Store({

    state: {
        logged_in: false,
        codalt: 'store',
        codalt_hystory: [],
        paese: '',
        cart: {
            count: 0,
        },
        elettrificazione: {
            k1: '',
            k2: '',
            k3: '',
            k4: '',
            k5: '',
            l1: '',
            l2: '',
            l3: '',
            l4: '',
            l5: '',
            l6: '',
        },
        linkspecifici: [
            "GIOGAPT000000BR-CRTRE271CE",
            "GIOGASP35-000BR-CRTRE271CE",
            "GIOGASP50-000CR-CRFUE271CE",
            "GIOGASP35-000BR-CRAME271CE",
            "GIOGASP65-000CR-CRTRE271CE",
            "GIOGASP65-000CR-CRORE271CE",
            "GIOGASP65-000CR-CRRAE271CE",
            "GIOGASP65-000CR-CRBRE271CE",
            "GIOGASP65-000CR-CRNNE271CE",
            "GIOGAPL80-000BR-CRTRE271CE",
            "GIOGAPL60-000BR-CRTRE271CE",
            "GIOGAPL50-000BR-CRTRE271CE",
            "GIOGAPL40-000BR-CRTRE271CE",
            "GIOGAAP000000CR-CRFU14E1CE",
            "GIOGASPCUB000CR-CRTRE271CE",
            "GIOGASPRE1000CR-CRTRE271CE",
            "GIOGASPOV1000CR-CRTRE271CE",
            "GIOGAPLCA1000CR-CRTRE271CE",
            "GIOGAPLCA2000CR-CRAME271CE",
            "MGIOGSP35-000CR-CRAME271CE",
            "MGIOGSP50-000CR-CRFUE271CE",
            "MGIOGPL50-000CR-CRTRE271CE",
            "MGIOGPL80-000CR-CRTRE271CE",
            "MGIOGPL60-000CR-CRTRE271CE",
            "MGIOGPL40-000CR-CRTRE271CE",
            "MGIOGSPRE2000CR-CRAME271CE",
            "MGIOGSPCLA000CR-NE--E271CE",
            "MGIOGPLCA3000CR-CRFUE271CE",
            "MGIOGLT000000BR-CRTRE271CE",
        ],
        linkspecifici_obj: {
            "GIOGAPT000000BR-CRTRE271CE": 117,
            "GIOGASP35-000BR-CRTRE271CE": 131,
            "GIOGASP50-000CR-CRFUE271CE": 131,
            "GIOGASP35-000BR-CRAME271CE": 131,
            "GIOGASP65-000CR-CRTRE271CE": 119,
            "GIOGASP65-000CR-CRORE271CE": 119,
            "GIOGASP65-000CR-CRRAE271CE": 119,
            "GIOGASP65-000CR-CRBRE271CE": 119,
            "GIOGASP65-000CR-CRNNE271CE": 119,
            "GIOGAPL80-000BR-CRTRE271CE": 129,
            "GIOGAPL60-000BR-CRTRE271CE": 129,
            "GIOGAPL50-000BR-CRTRE271CE": 129,
            "GIOGAPL40-000BR-CRTRE271CE": 129,
            "GIOGAAP000000CR-CRFU14E1CE": 117,
            "GIOGASPCUB000CR-CRTRE271CE": 131,
            "GIOGASPRE1000CR-CRTRE271CE": 131,
            "GIOGASPOV1000CR-CRTRE271CE": 132,
            "GIOGAPLCA1000CR-CRTRE271CE": 132,
            "GIOGAPLCA2000CR-CRAME271CE": 132,
            "MGIOGSP35-000CR-CRAME271CE": 131,
            "MGIOGSP50-000CR-CRFUE271CE": 131,
            "MGIOGPL50-000CR-CRTRE271CE": 130,
            "MGIOGPL80-000CR-CRTRE271CE": 130,
            "MGIOGPL60-000CR-CRTRE271CE": 130,
            "MGIOGPL40-000CR-CRTRE271CE": 130,
            "MGIOGSPRE2000CR-CRAME271CE": 131,
            "MGIOGSPCLA000CR-NE--E271CE": 131,
            "MGIOGPLCA3000CR-CRFUE271CE": 131,
            "MGIOGLT000000BR-CRTRE271CE": 118,
            "ARMONSPOV1000N_OMC1-E141CE": 235,
            "ARMONSPOV1000N_OMC2-E141CE": 235,
            "ARMONSPOV1000N_OMC3-E141CE": 235,
            "ARMONSPOV1000N_RMC1-E141CE": 235,
            "ARMONSPOV1000N_RMC2-E141CE": 235,
            "ARMONSPOV1000N_RMC3-E141CE": 235,
            "ARMONAP14-000BKSCRRBE141CE": 235,
            "ARMONAP14-000BKSFURBE141CE": 235,
            "ARMONAP14-000NNSCRRBE141CE": 235,
            "ARMONAP14-000NNSFURBE141CE": 235,
            "ARMONAP15-000BKSCRRVE141CE": 235,
            "ARMONAP15-000BKSFURVE141CE": 235,
            "ARMONAP15-000BKSTBRVE141CE": 235,
            "ARMONAP15-000NNSCRRVE141CE": 235,
            "ARMONAP15-000NNSFURVE141CE": 235,
            "ARMONAP15-000NNSTBRVE141CE": 235,
            "ARMONAP18-000BKSAMBTE141CE": 235,
            "ARMONAP18-000BKSCRBTE141CE": 235,
            "ARMONAP18-000NNSAMBTE141CE": 235,
            "ARMONAP18-000NNSCRBTE141CE": 235,
            "ARMONAP20-000BKSCRRIE141CE": 235,
            "ARMONAP20-000NNSCRRIE141CE": 235,


        },
        linkmuseo: {
            "24PEASP": "40",
            "ALEGALT": "141",
            "ARIASP": "55",
            "ARMONAP": "49",
            "ARMONSP": "49",
            "ASSIBAP": "37",
            "ASSIBLT": "143",
            "ASSIBSP": "37",
            "AURORAP": "124",
            "AURORPL": "124",
            "BACOAP": "71",
            "BACOSP": "71",
            "BALANAP": "56",
            "BALANPL": "56",
            "BALANSP": "56",
            "BISSALT": "143",
            "BISSOLT": "143",
            "BOLLEFA": "55",
            "BOLLELT": "55",
            "BOLLEPB": "55",
            "BOLLEPL": "55",
            "BOLLESP": "55",
            "BOTAP": "61",
            "BOTFA": "61",
            "BOTLT": "61",
            "BOTPL": "61",
            "BOTSP": "61",
            "CANDESP": "107",
            "CLOTHAP": "52",
            "CLOTHLT": "52",
            "CLOTHPT": "52",
            "CLOTHSP": "52",
            "CRISTSP": "42",
            "DAMASAP": "113",
            "DAMASFA": "113",
            "DAMASLT": "113",
            "DAMASPT": "113",
            "DAMASSP": "113",
            "DIADEAP": "70",
            "DIADEFA": "70",
            "DIADELT": "70",
            "DIADEPL": "70",
            "DIADEPT": "70",
            "DIADESP": "70",
            "DIAMAFA": "48",
            "DIAMAPL": "48",
            "DIAMASP": "48",
            "DRESSAP": "67",
            "DRESSSP": "67",
            "ECOSAP": "79",
            "ECOSPL": "79",
            "ECOSPT": "78",
            "ECOSSP": "78",
            "ESSENSP": "76",
            "FEREALT": "143",
            "FUTURAP": "22",
            "FUTURLT": "22",
            "FUTURPL": "22",
            "FUTURPT": "22",
            "FUTURSP": "13",
            "GIO3DSP": false,
            "GIOGAAP": false,
            "GIOGAPL": "128",
            "GIOGAPT": "116",
            "GIOGASP": "118",
            "IMPLOFA": "66",
            "IMPLOLT": "66",
            "IMPLOPL": "66",
            "IMPLOSP": "66",
            "INCANPL": "119",
            "INCANSP": "119",
            "INFINAP": "63",
            "INFINPL": "63",
            "INFINSP": "63",
            "JUBEAP": "30",
            "JUBELT": "138",
            "JUBEPT": "138",
            "JUBESP": "30",
            "KIRASP": "66",
            "LACRISP": "100",
            "LEPANPT": "114",
            "LEPANSP": "114",
            "LIOAP": "102",
            "LIOFA": "102",
            "LIOLT": "102",
            "LIOPL": "102",
            "LIOPT": "102",
            "LIOSP": "102",
            "LUCCIAP": "68",
            "LUCCIFA": "68",
            "LUCCILT": "68",
            "LUCCIPL": "68",
            "LUCCIPT": "68",
            "LUCCISP": "68",
            "MEDEASP": "36",
            "MGIOGAP": false,
            "MGIOGLT": "117",
            "MGIOGPL": "129",
            "MGIOGPT": false,
            "MGIOGSP": "130",
            "MIAAP": "122",
            "MIAPL": "122",
            "MIRAGSP": "69",
            "MORISAP": "122",
            "MORISPL": "122",
            "MUNEGLT": "143",
            "NARANSP": "74",
            "NAXOSLT": "58",
            "NAXOSPT": "58",
            "NAXOSSP": "58",
            "NEOCHAP": "59",
            "NEOCHPL": "59",
            "NEOCHSP": "59",
            "NESSALT": "143",
            "NINFESP": "64",
            "NODOSP": "67",
            "NOVECLT": "34",
            "NOVECPL": "137",
            "NOVECPT": "137",
            "NOVECSP": "34",
            "OTOSP": "11",
            "PEGGYAP": "8",
            "PEGGYPT": "8",
            "PEGGYSP": "8",
            "PHOENSP": "32",
            "PLOTFAP": "19",
            "PLOTFPT": "140",
            "PLOTFSP": "19",
            "PLOTSP": "19",
            "POCFA": "46",
            "POCLT": "46",
            "POCSP": "44",
            "PODAP": "122",
            "PODPL": "122",
            "PUPPEAP": "4",
            "PUPPELT": "4",
            "PUPPESP": "4",
            "PUPRIAP": "36",
            "PUPRISP": "36",
            "RIFLELT": "25",
            "RIFLESP": "25",
            "RINAFA": "17",
            "RINALT": "17",
            "RINAPL": "17",
            "RINAPT": "17",
            "RINASP": "17",
            "SABAAP": "122",
            "SABAPL": "122",
            "SATALT": "137",
            "SATAPT": "137",
            "SATASP": "137",
            "SEMAIAP": "50",
            "SEMAIPL": "50",
            "SEMAISP": "50",
            "SISSISP": "108",
            "SOGNOAP": "122",
            "SOGNOPL": "122",
            "SPIRIAP": "33",
            "SPIRILT": "33",
            "SPIRIPL": "33",
            "SPIRISP": "33",
            "STONESP": "38",
            "STRDUAP": "106",
            "STRDULT": "106",
            "STRDUSP": "106",
            "STRNESP": "108",
            "SURFASP": "58",
            "TREADAP": "28",
            "TREADLT": "28",
            "TREADSP": "28",
            "TREPAPT": "137",
            "TUBESPL": "98",
            "TUBESSP": "98",
            "WITHWPL": "110",
            "WITHWSP": "110",
            "ANISESP": "229",
            "RIKETSP": "230",
            "SCINTSP": "231",
            /*   "INFINSP":"232", */
            /*   "INFINPL":"232", */
            /*   "INFINAP":"232", */
            /*   "INCANSP":"234", */
            /*   "INCANPL":"234", */
            /*   "ARMONSP":"235", */
            /*   "ARMONAP":"235", */
            "FAROSP": "237",
            "FAROPL": "237",
            "PLISSPL": "238",



        },
        linkmuseo_l: [
            "24PEASP",
            "ALEGALT",
            "ARIASP",
            "ARMONAP",
            "ARMONSP",
            "ASSIBAP",
            "ASSIBLT",
            "ASSIBSP",
            "AURORAP",
            "AURORPL",
            "BACOAP",
            "BACOSP",
            "BALANAP",
            "BALANPL",
            "BALANSP",
            "BISSALT",
            "BISSOLT",
            "BOLLEFA",
            "BOLLELT",
            "BOLLEPB",
            "BOLLEPL",
            "BOLLESP",
            "BOTAP",
            "BOTFA",
            "BOTLT",
            "BOTPL",
            "BOTSP",
            "CANDESP",
            "CLOTHAP",
            "CLOTHLT",
            "CLOTHPT",
            "CLOTHSP",
            "CRISTSP",
            "DAMASAP",
            "DAMASFA",
            "DAMASLT",
            "DAMASPT",
            "DAMASSP",
            "DIADEAP",
            "DIADEFA",
            "DIADELT",
            "DIADEPL",
            "DIADEPT",
            "DIADESP",
            "DIAMAFA",
            "DIAMAPL",
            "DIAMASP",
            "DRESSAP",
            "DRESSSP",
            "ECOSAP",
            "ECOSPL",
            "ECOSPT",
            "ECOSSP",
            "ESSENSP",
            "FEREALT",
            "FUTURAP",
            "FUTURLT",
            "FUTURPL",
            "FUTURPT",
            "FUTURSP",
            "GIO3DSP",
            "GIOGAAP",
            "GIOGAPL",
            "GIOGAPT",
            "GIOGASP",
            "IMPLOFA",
            "IMPLOLT",
            "IMPLOPL",
            "IMPLOSP",
            "INCANPL",
            "INCANSP",
            "INFINAP",
            "INFINPL",
            "INFINSP",
            "JUBEAP",
            "JUBELT",
            "JUBEPT",
            "JUBESP",
            "KIRASP",
            "LACRISP",
            "LEPANPT",
            "LEPANSP",
            "LIOAP",
            "LIOFA",
            "LIOLT",
            "LIOPL",
            "LIOPT",
            "LIOSP",
            "LUCCIAP",
            "LUCCIFA",
            "LUCCILT",
            "LUCCIPL",
            "LUCCIPT",
            "LUCCISP",
            "MEDEASP",
            "MGIOGAP",
            "MGIOGLT",
            "MGIOGPL",
            "MGIOGPT",
            "MGIOGSP",
            "MIAAP",
            "MIAPL",
            "MIRAGSP",
            "MORISAP",
            "MORISPL",
            "MUNEGLT",
            "NARANSP",
            "NAXOSLT",
            "NAXOSPT",
            "NAXOSSP",
            "NEOCHAP",
            "NEOCHPL",
            "NEOCHSP",
            "NESSALT",
            "NINFESP",
            "NODOSP",
            "NOVECLT",
            "NOVECPL",
            "NOVECPT",
            "NOVECSP",
            "OTOSP",
            "PEGGYAP",
            "PEGGYPT",
            "PEGGYSP",
            "PHOENSP",
            "PLOTFAP",
            "PLOTFPT",
            "PLOTFSP",
            "PLOTSP",
            "POCFA",
            "POCLT",
            "POCSP",
            "PODAP",
            "PODPL",
            "PUPPEAP",
            "PUPPELT",
            "PUPPESP",
            "PUPRIAP",
            "PUPRISP",
            "RIFLELT",
            "RIFLESP",
            "RINAFA",
            "RINALT",
            "RINAPL",
            "RINAPT",
            "RINASP",
            "SABAAP",
            "SABAPL",
            "SATALT",
            "SATAPT",
            "SATASP",
            "SEMAIAP",
            "SEMAIPL",
            "SEMAISP",
            "SISSISP",
            "SOGNOAP",
            "SOGNOPL",
            "SPIRIAP",
            "SPIRILT",
            "SPIRIPL",
            "SPIRISP",
            "STONESP",
            "STRDUAP",
            "STRDULT",
            "STRDUSP",
            "STRNESP",
            "SURFASP",
            "TREADAP",
            "TREADLT",
            "TREADSP",
            "TREPAPT",
            "TUBESPL",
            "TUBESSP",
            "WITHWPL",
            "WITHWSP",
            "ANISESP",
            "RIKETSP",
            "SCINTSP",
            /* "INFINSP" , */
            /* "INFINPL" , */
            /* "INFINAP" , */
            /* "INCANSP" , */
            /* "INCANPL" , */
            /* "ARMONSP" , */
            /* "ARMONAP" , */
            "FAROSP",
            "FAROPL",
            "PLISSPL",
        ],
        modello_selected: {
            'MODELLO': '',
            'VETRO': '',
            'MONTATURA': '',
            'SORGENTE': '',
            'PAESE': '',
        },
        status: {
            status: 'INIT',
            url: 'test',
            start: 'start'
        },
        group_vetro: {
            LIST: []
        },
        occhio: {

            occhio: '<div id="occhio-centrato" class="occhio-centrato 2"> <a href="https://www.vistosi.it/vistosivirtualmuseum/">  <input type="image" style="padding:0px"; src="https://vistosi.it/wp-content/uploads/2021/09/OCCHIO.svg" /> <h6 style="color:#686868; max-width:100px; text-align: center">Vedi nel museo </h6> </a> </div> '
        },
        ricambi: {
            quantita: '',
            disponibile: '',
            codice: '',
            data_disponibilita: '',
            prezzo: '',
        },
        product: {
            wid: '',
            showid: false,
            modello_var: '',
            language: 'ita',
            europe: true,
            usa: false,
            id: '',
            vetro: '',
            vetri: '',
            finiture: '',
            finiture_list: '',
            led: '',
            paese: 'CE',
            leds: [],
            leds_old: [],
            quantita: {
                DATA: '',
                DISPONIBILE: '',
                FATTIBILE: ''
            },
            'quantity': 1,
            'prezzo': 0,
            codice_listino: 0,
        },
        products_store: {
            PREZZI: [],
            PREZZI_PER_LISTINO: [],
            DETAILS: [],
            CODICI: [],
            MODELLO: [],
            MODELLO_VAR: [],
            COLOREVETRO: [],
            FINITURASTRUTTURA: [],
            SORGENTE: [],
            SORGENTE_PRODUCTS: [],
            SORGENTE_LUMINOSA: [],
            SORGENTE_PRODUCT: [],
            CODICE_UNIVOCO_LIST: [],
            PRODOTTI_VENDIBILI: [],
            PAESE_PRODUCT: '',
            CERTIFICAZIONI: [],
            // è UN ARRAY CHE MI SERVE PER VISUALIZZARE LE FINITURE METALLICHE
            FINITURASTRUTTURA_ARRAY: [],
            FINITURASTRUTTURA_ARRAY_BACKUP: [],
            MONTATURASET: false,
            VETROSET: false,
        },
        product_store: {
            MODELLO_VAR: '',
            VETRO: '',
            MONTATURA: '',
            SORGENTE: '',
            PAESE: '',
            CODICE_UNIVOCO: '',
            DATA_DISPONIBILE: '',
            DISPONIBILITA: '',
            PREZZO: '',
            QUANTITA_RICHIESTA: 1,
            CODICE_UNIVOCO_CLICK_MODELLI: '',
            ORDINATO: false,
        },
        products: {
            debug: false,
            'CE': [],
            'UL': [],
            'VETRO': [],
            'FINITURE': [],
            'SORGENTE': [],
            'ALL': [],
        },
        breadcrumbs: {
            tita: '',
            ten: '',
            fita: '',
            fen: ''
        },
        ita: {
            famiglia: 'Futura',
            countprodotto: 10,
            finituravetro_text: 'FINITURA VETRO',
            sorgenteluminosa: 'SORGENTE LUMINOSA',
            certificazioni: 'CERTIFICAZIONI',
            codicearticolo: 'CODICE ARTICOLO',
            disponibilita: 'DISPONIBILITÀ',
            dispo: '0',
            disponibilità_top_text: "Disponibilità",
            disponibilita_al: 'Consegna prevista',
            quantita: 'QUANTITÀ',
            prezzo: 'PREZZO',
            ordina: 'AGGIUNGI AL CARRELLO',
            ordinando: 'INVIA QUOTAZIONE',
            ordineinserito: 'ORDINE INSERITO',
            vedicarrello: 'VEDI CARRELLO',
            vediricambi: 'VEDI RICAMBI',
            codice_articolo: 'CODICE ARTICOLO',
            zona: 'Europe/International',
            zona_u: 'Usa&Canada',
            codicearticolo_title: 'CODICE ARTICOLO',
            usa: false,
            europe: true, // questa variabile serve a preselezionare i prodotti per il mercato erupeo se è un cliente non è europea allora devo settarla a falso
            paese: 'CE',
            tipologie_prodotti: '',
            listacontuttelesorgenti: '',
            PREZZO: 'PREZZO',
            data_prox_disponibilita: 'DATA PROSSIMA DISPONIBILITÀ',
            quantita_ricambi: 'QUANTITÀ RICAMBI',
            alert: '(*) alla data esposta si devono aggiungere circa 5 giorni lavorativi quali tempi medi di approntamento del materiale. La data effettiva di consegna sarà quella indicata nella conferma d\'ordine.',
            ricambi_info: 'SELEZIONA IL RICAMBIO',
            ricambi_title: 'Ricambi',
            ORDINA_NAME_TITLE: 'AGGIUNGI AL CARRELLO',
            ORDINA_NAME_TITLE_LOADING: 'AGGIUNGI AL CARRELLO'
        },
        order: {
            isloading: false,
        },
        en: {
            famiglia: 'Futura',
            countprodotto: 10,
            finituravetro_text: 'FINITURA VETRO',
            sorgenteluminosa: 'SORGENTE LUMINOSA',
            certificazioni: 'CERTIFICAZIONI',
            codicearticolo: 'CODICE ARTICOLO',
            disponibilita: 'AVAILABILITY',
            dispo: '0',
            disponibilità_top_text: "Disponibilità",
            disponibilita_al: 'Scheduled delivery',
            quantita: 'QUANTITÀ',
            prezzo: 'PREZZO',
            ordina: 'ADD TO CART',
            ordinando: 'PLACING ORDER',
            ordineinserito: 'ORDER PLACED',
            vedicarrello: 'CART',
            codice_articolo: 'ITEM NUMBER',
            vediricambi: 'REPLACEMENT',
            zona: 'Europe/International',
            zona_u: 'Usa&Canada',
            codicearticolo_title: 'CODICE ARTICOLO',
            usa: false,
            europe: true, // questa variabile serve a preselezionare i prodotti per il mercato erupeo se è un cliente non è europea allora devo settarla a falso
            paese: 'CE',
            tipologie_prodotti: '',
            listacontuttelesorgenti: '',
            PREZZO: 'PRICE',
            data_prox_disponibilita: 'Date availability',
            quantita_ricambi: 'REPLACEMENT AVAILABILITY',
            alert: '(*) approximately 5 working days must be added to the date shown as average preparation times for the material. The actual delivery date will be the one indicated in the order confirmation.',
            ricambi_info: 'Select an item to view the spare parts available',
            ricambi_title: 'REPLACEMENTS',
            ORDINA_NAME_TITLE: 'ADD TO CART',
            ORDINA_NAME_TITLE_LOADING: 'ADD TO CART'

        },


        // DOWNLOADER APP STORE
        items: {


            item1:
                [
                    {
                        nameId: "1",
                        title: "Istruzioni di montaggio",
                        subtitle: "PDF",
                        activeItem: false,
                        iconText: "mdi-circle-outline",
                        selected: false,
                        active: "disabled",
                    },

                ],
            item2:
                [
                    {
                        nameId: "2",
                        title: "Scheda collezione",
                        subtitle: "PDF",
                        activeItem: false,
                        iconText: "mdi-circle-outline",
                        selected: false,
                        active: "disabled",
                    }
                ],
            item3:
                [
                    {
                        nameId: "3",
                        title: "Scheda prodotto",
                        subtitle: "PDF",
                        activeItem: false,
                        iconText: "mdi-circle-outline",
                        selected: false,
                        active: "disabled",
                    },

                ],
            item4:
                [
                    {
                        nameId: "4",
                        title: "Modelli 2D",
                        subtitle: "DWG",
                        activeItem: false,
                        iconText: "mdi-circle-outline",
                        selected: false,
                        active: "disabled",

                    }
                ],
            item5:
                [
                    {
                        nameId: "5",
                        title: "Modelli 3D",
                        subtitle: "EASM, FBX, 3DS ",
                        subtitle2: "3DS Download",
                        activeItem: false,
                        iconText: "mdi-circle-outline",
                        selected: false,
                        active: "disabled",
                    },

                ],
            item6:
                [
                    {
                        nameId: "6",
                        title: "Libreria Texture",
                        subtitle: "PDF",
                        activeItem: false,
                        iconText: "mdi-circle-outline",
                        selected: false,
                        active: "disabled",
                    }
                ],

            item7:
                [
                    {
                        nameId: "6",
                        title: "Certificazioni",
                        subtitle: "PDF",
                        activeItem: false,
                        iconText: "mdi-circle-outline",
                        selected: false,
                        active: "disabled",
                    }
                ],
        },
        button_download: {
            disabled: true
        }

    },
    actions: {
        getFamilyInfo: (store, data) => {
            let g = new getProductType();
            g.getProductType(store, data);

        },


    },
    getters: {
        get_showproduct: (store) => {
            return store.product.showid;
        },
        get_product: (store) => {
            return store.product
        }
        , get_products: (store) => {
            return store
        }
        , get_vetro_selected: (store) => {
            return store.product.vetro;
        }
        , get_vetri_selected: (store) => {
            return store.product.vetri;
        }
        , get_finiture_selected: (store) => {
            return store.product.finiture;
        }
        , get_finiture_list_selected: (store) => {
            return store.product.finiture_list;
        }
        , get_let_selected: (store) => {
            return store.product.led;
        }
        , get_paese_selected: (store) => {
            return store.product.paese;
        }
        , get_filtered_produts_vetro_finiture_sorgente: (store) => {
            return store.products.SORGENTE;
        }
        , get_status: (state) => {
            return state.status.status;
        }
        , get_url: (store) => {
            return store.STATUS.url;
        }

    },
    mutations: {
        logged_in(store, data) {
            store.logged_in = data.logged_in;
        },
        change_cart_count(store, data) {
            store.cart.count = data.count;
        },
        get_cart_count(store) {
            let c = new cart();
            c.get_count(store);
        },
        is_loading_order(store, data) {
            store.order.isloading = data.is_loading;
        },
        is_loading_downloader(store, data) {
            store.order.isloading = data.is_loading;
        },
        json_taken: (store, data) => {
            store.products_store.PREZZI = data;
        },
        json_taken_certificazioni: (store, data) => {
            store.products_store.CERTIFICAZIONI = data;
        },
        json_taken_details: (store, data) => {
            store.products_store.DETAILS = data;
        },
        json_taken_codici: (store, data) => {
            store.products_store.CODICI = data;
        },
        json_taken_finiturastruttura: (store, data) => {
            store.products_store.FINITURASTRUTTURA_ARRAY = data;
            store.products_store.FINITURASTRUTTURA_ARRAY_BACKUP = data;
            try {
                if (store.products_store.MONTATURASET) {
                    let c = store.products_store.MONTATURASET;
                    let f = new filter_array();
                    store.products_store.FINITURASTRUTTURA_ARRAY = f.select_by_key_value(data, 'FINITURASTRUTTURA', c, 'SELECTED');
                }
            } catch (error) {
                console.info(error)

            }
        },
        filter_for_listino(store) {
            let f = new filter_array();
            let product_list = f.key_value(store.products_store.PREZZI, 'Codice_listino', store.product.codice_listino);
            store.products_store.PREZZI_PER_LISTINO = product_list;
            console.info('mutation filter for listino', product_list, store.product.codice_listino);
        },
        group_by_model(store) {
            // group array by key value
            let f = new filter_array();
            let product_list = f.group_by(store.products_store.PREZZI_PER_LISTINO, 'MODELLO');
            store.products_store.MODELLO = product_list;
            product_list = f.group_by(store.products_store.PREZZI_PER_LISTINO, 'MODELLO_VAR');
            store.products_store.MODELLO_VAR = product_list;
            product_list = f.group_by(store.products_store.PREZZI_PER_LISTINO, 'COLOREVETRO');
            store.products_store.COLOREVETRO = product_list;
            product_list = f.group_by(store.products_store.PREZZI_PER_LISTINO, 'FINITURASTRUTTURA');
            store.products_store.FINITURASTRUTTURA = product_list;
            product_list = f.group_by(store.products_store.DETAILS, 'SORGENTE');
            console.info('before sorgente:', store.products_store.SORGENTE);
            store.products_store.SORGENTE = product_list;
            console.info('AFTER sorgente:', store.products_store.SORGENTE);

            store.products_store.SORGENTE_PRODUCTS =
                f.group_by_type(store.products_store.DETAILS, store.products_store.SORGENTE, 'SORGENTE')

            console.info('raggruppo 2', store.product_store.SORGENTE_PRODUCTS);

            store.products_store.CODICE_UNIVOCO_LIST = f.group_by(store.products_store.PREZZI_PER_LISTINO, 'CODICE_UNIVOCO');
            store.products_store.PRODOTTI_VENDIBILI = f.group_by_type(
                store.products_store.DETAILS, store.products_store.CODICE_UNIVOCO_LIST, 'id_prodotto'
            );

            console.info('mutation group by model ', product_list);
        },
        vetro_by_product_id: (store, data) => {
            console.info('mutatio vetro by product id', data);
            let f = new filter_array();
            if (!f.exist_value_in_array(store.products_store.CODICE_UNIVOCO_LIST, data.product_id)) {
                data.product_id = store.products_store.CODICE_UNIVOCO_LIST[0];
            }
            store.product_store.CODICE_UNIVOCO = data.product_id;
            let PRODOTTO = f.key_value(store.products_store.DETAILS, 'id_prodotto', data.product_id);
            let vetro;
            if (PRODOTTO.length > 0) {
                vetro = f.group_by(PRODOTTO, 'COLOREVETRO');
            } else {
                vetro = [store.products_store.COLOREVETRO[0]];
            }
            store.product_store.VETRO = vetro[0];
        },
        filter_modelli: (store) => {
            let f = new filter_array();
            let product_list = f.key_value(store.products_store.DETAILS, 'COLOREVETRO',
                store.product_store.VETRO);
            // product list sono tutti i prodotti con quel vetro ...
            // da qui ottengo i modelli var 
            let modelli = f.group_by_modello_e_modello_var(
                product_list,
                store.products_store.MODELLO_VAR,
                store.products_store.MODELLO);
            store.products.SORGENTE = modelli;
        },
        filter_glass: (store) => {
            let f = new filter_array();
            let product_vetri = f.group_by_type(
                store.products_store.DETAILS,
                store.products_store.COLOREVETRO,
                'COLOREVETRO');
            let vetri = [];
            let item = {};
            try {
                product_vetri.forEach((vetro) => {
                    let finiture;
                    if (vetro.COLOREVETRO.length == 4) {
                        let a = vetro.COLOREVETRO.substring(0, 2);
                        let b = vetro.COLOREVETRO.substring(2, 4);
                        finiture = a + '/' + b;
                    } else {
                        finiture = vetro.COLOREVETRO;
                    }
                    let c = new checkLanguage();
                    let i = c.is_italian();
                    let ln = '';
                    if (i) {
                        ln = vetro.VETRO_ITA;
                    } else {
                        ln = vetro.VETRO_ENG;
                    }
                    item = {
                        'COLOREVETRO': vetro.COLOREVETRO,
                        'IMG': vetro.img_finiturevetro,
                        'SELECTED': false,
                        'finiturastrutturatesto': finiture,
                        'VETRO_ITA': vetro.VETRO_ITA,
                        'VETRO_ENG': vetro.VETRO_ENG,
                        'VETRO_LANG': ln
                    }
                    vetri.push(item);
                });
            } catch (error) {
                console.info(error);
            }
            store.product.vetri_new = vetri;
        },
        select_product_by_id: (store, data) => {
            store.status.start = 'loaded';
            let ID_PRODUCT = data;
            let f = new filter_array();
            let a = store.products.SORGENTE;
            let b = store.products_store.DETAILS;
            let v = store.product.vetri_new;
            let fs = store.products_store.FINITURASTRUTTURA_ARRAY;
            let sp = store.products_store.SORGENTE_PRODUCTS;
            console.info('raggruppo 3', sp);
            let pv = store.products_store.PREZZI_PER_LISTINO;
            let c = f.select_by_key_value_one(b, 'id_prodotto', ID_PRODUCT, 'modello_var');
            store.product_store.MODELLO_VAR = c;
            let d = f.select_by_key_value_one(b, 'id_prodotto', ID_PRODUCT, 'MODELLO');
            store.product_store.MODELLO = d;
            let modello_var = c;
            let Modello = d;
            store.products.SORGENTE = f.select_by_modello_and_modello_var(a, modello_var, Modello)
            c = f.select_by_key_value_one(b, 'id_prodotto', ID_PRODUCT, 'COLOREVETRO');
            store.product_store.VETRO = c;
            store.products_store.VETROSET = c;
            try {
                if (!v.length == 0) {
                    store.product.vetri_new = f.select_by_key_value(v, 'COLOREVETRO', c, 'SELECTED')
                }
            } catch (e) {
                console.info(e);
            }
            c = f.select_by_key_value_one(b, 'id_prodotto', ID_PRODUCT, 'testo_finiturastruttura');
            store.product_store.MONTATURA = c;
            // in questo momento la variabile non è valorizzata quindi non posso andare a mettere select a tru a qualcosa che non ha un valore 
            if (fs.length == 0) {
                store.products_store.MONTATURASET = c;
            } else {
                store.products_store.FINITURASTRUTTURA_ARRAY = f.select_by_key_value(fs, 'FINITURASTRUTTURA', c, 'SELECTED')
            }
            c = f.select_by_key_value_one(b, 'id_prodotto', ID_PRODUCT, 'SORGENTE');
            store.product_store.SORGENTE = c;
            store.products_store.SORGENTE_PRODUCT = f.select_by_key_value_one_array(sp, 'SORGENTE', c);
            let PAESE = f.select_by_key_value_one(b, 'id_prodotto', ID_PRODUCT, 'PAESE');
            store.product_store.PAESE = PAESE;
            store.product_store.CODICE_UNIVOCO = data;
            c = f.select_by_key_value_one(b, 'id_prodotto', ID_PRODUCT, 'DATA');
            store.product_store.DATA_DISPONIBILE = c;
            c = f.select_by_key_value_one(b, 'id_prodotto', ID_PRODUCT, 'DISPONIBILE');
            store.product_store.DISPONIBILITA = c;
            c = f.select_by_key_value_one_listino(pv, 'CODICE_UNIVOCO', ID_PRODUCT, 'Prezzo_di_vendita', store.product.codice_listino);
            store.product_store.PREZZO = c;
            c = f.select_by_key_value_one_listino(pv, 'CODICE_UNIVOCO', ID_PRODUCT, 'Prezzo_di_vendita', store.product.codice_listino);
            c = f.select_by_key_value_one(b, 'id_prodotto', ID_PRODUCT, 'img_left');
            let IMG = '';
            let tipologia = f.select_by_key_value_one(b, 'id_prodotto', ID_PRODUCT, 'tipologia');
            if (tipologia == 'PL') {
                IMG = f.select_by_key_value_one(b, 'id_prodotto', ID_PRODUCT, 'IMG_C');
            } else {
                IMG = f.select_by_key_value_one(b, 'id_prodotto', ID_PRODUCT, 'IMG_A');
            }
            store.product_store.IMG = c;
            // chenge img_left 
            let img = new change_img();
            let ur = new is_localhost();
            let url = ur.return_url_website();
            let img_url = url + 'risorse/prodotto/' + IMG;
            img.change_img(img_url, store);

            //  se si tratta di lio sp allora filtrami i modelli 

        },

        setta_quantita_richiesta: (store, data) => {
            store.product_store.QUANTITA_RICHIESTA = data;
        },
        setta_quantita_ricambi_richiesta: (store, data) => {
            store.ricambi.quantita = data;
        },
        get_modelli_to_display_from_vetro_and_montatura(store, data) {
            // qui devo scegliere i modelli da mostrare avemdp a disposizione moddello e montatura 
            // cosa succede però che se cambio la srogente luminosa mi mostra troppi modelli
            // 
            console.info('store get_modelli_to_display_from_vetro_and_montatura');
            console.info('store get_modelli', store);
            try {


                if (store.products.SORGENTE[0].FAMIG_ESTESA == 'LIO'
                    && store.products.SORGENTE[0].tipologia == 'LT'
                ) {
                    console.info('store get_modelli_to_display_from_vetro_and_montatura', 'is lio');
                    let fr = new filter_array();
                    let a = store.products_store.PRODOTTI_VENDIBILI;
                    console.info('filtro per paese', a);
                    let c = fr.select_from_array_key_value(a, 'PAESE', store.product.paese);
                    store.products.SORGENTE = c;
                }

                if (store.products.SORGENTE[0].FAMIG_ESTESA == 'OTO'
                    || store.products.SORGENTE[0].FAMIG_ESTESA == 'LUCCIOLA'
                    || store.products.SORGENTE[0].FAMIG_ESTESA == 'ORO'
                    || (store.products.SORGENTE[0].FAMIG_ESTESA == 'BOLLE' && store.products.SORGENTE[0].tipologia == 'FA')
                    || store.products.SORGENTE[0].FAMIG_ESTESA == 'PUPPET'
                    || store.products.SORGENTE[0].FAMIG_ESTESA == 'PHOENIX'
                    || store.products.SORGENTE[0].FAMIG_ESTESA == 'PUPPET RING'
                    || store.products.SORGENTE[0].FAMIG_ESTESA == 'RINA'
                    || store.products.SORGENTE[0].FAMIG_ESTESA == 'RIFLESSO'
                    || store.products.SORGENTE[0].FAMIG_ESTESA == 'TREAD'
                    || store.products.SORGENTE[0].FAMIG_ESTESA == 'ARMONIA'
                    || (store.products.SORGENTE[0].FAMIG_ESTESA == 'LIO'
                        && store.products.SORGENTE[0].tipologia != 'LT')

                ) {
                    console.info('mutation get_modelli_to_display_from_vetro_and_montatura ');
                    console.info('store get_modelli_to_display_from_vetro_and_montatura', 'B');
                    let fr = new filter_array();
                    let a = store.products_store.PRODOTTI_VENDIBILI;
                    let vetro = data.VETRO;
                    let montatura = data.MONTATURA;
                    let MODELLO = data.MODELLO;
                    let MODELLO_VAR = data.MODELLOVAR;
                    let SORGENTE = data.SORGENTE;
                    let c = fr.select_from_array_key_value(a, 'COLOREVETRO', vetro);
                    console.info('store get_modelli_to_display_from_vetro_and_montatura',

                        'Vendibili:', a,
                        'VETRO:', vetro,
                        'MONTATURA:', montatura,
                        'MODELLO:', MODELLO,
                        'MODELLO VAR:', MODELLO_VAR,
                        'SORGENTE', SORGENTE,
                        'select from array key', c
                    );
                    let d = fr.select_from_array_key_value(c, 'testo_finiturastruttura', montatura);
                    if (store.products.SORGENTE[0].FAMIG_ESTESA == 'LIO') {
                        // prendi quelli con immagini diverse ?
                        d = fr.seleziona_prodotti_con_immagini_diverse(d);
                        store.products.SORGENTE = d;
                        console.info('store get_modelli_to_display_from_vetro_and_montatura', 'C');
                    } else {
                        console.info('store get_modelli_to_display_from_vetro_and_montatura', 'D');
                        let e = fr.select_from_array_key_value(d, 'SORGENTE', SORGENTE);
                        // QUESTA FUNZIONE MI ABILITA LA FOTO (SELECTED A TRUE) 
                        let f = fr.select_by_key_value_mv(e, MODELLO, MODELLO_VAR);
                        console.info('store get_modelli_to_display_from_vetro_and_montatura', a, c, d, e, f);
                        store.products.SORGENTE = f;
                    }

                }

            } catch (error) {
                console.info('store get_modelli', error);

            }
        },
        search_id_product_by_modello_var: (store, data) => {
            try {


                let f = new filter_array();
                let a = store.products_store.PRODOTTI_VENDIBILI;
                let product = store.product_store;
                let c = f.select_by_key_value_one_array(a, 'COLOREVETRO', product.VETRO);
                if (store.products.SORGENTE[0].FAMIG_ESTESA != 'LIO') {
                    c = f.select_by_key_value_one_array(c, 'testo_finiturastruttura', product.MONTATURA);
                }
                c = f.select_by_key_value_one_array(c, 'modello_var', data.modello_var);
                let d_modelli = f.get_modelli(c);
                if (d_modelli.includes(data.MODELLO)) {
                    c = f.select_by_key_value_one_array(c, 'MODELLO', data.MODELLO);
                } else {
                    c = f.select_by_key_value_one_array(c, 'MODELLO', d_modelli[0]);
                }
                let id_prodotto = '';
                if (c.length > 0) {
                    try {
                        if (typeof (store.product_store.SORGENTEBIS) !== 'undefined') {
                            if (store.product_store.SORGENTEBIS.length > 0) {

                                c = f.select_by_key_value_one_array(c, 'SORGENTE', store.product_store.SORGENTEBIS);
                                if (c.length == 0) {
                                    c = f.select_by_key_value_one_array(store.products_store.PRODOTTI_VENDIBILI, 'SORGENTE', store.product_store.SORGENTEBIS);
                                    console.info('location reload');
                                    store.product_store.VETRO;
                                    store.product_store.montaturaVETRO;
                                    store.product_store.SORGENTEVETRO;
                                    store.product_store.MODELLO_VAR;
                                    console.info('location reload',
                                        'vetro', store.product_store.VETRO,
                                        'montatura', store.product_store.montaturavetro,
                                        'sorgente', store.product_store.SORGENTEVETRO,
                                        'modello var', store.product_store.MODELLO_VAR,
                                        'generale', store.product_store,
                                        'store', store,
                                        'c', c,
                                        'data', data,
                                        'vendibili', store.products_store.PRODOTTI_VENDIBILI
                                    );
                                    try {
                                        let vendibili = store.products_store.PRODOTTI_VENDIBILI;
                                        c = vendibili.filter((vendibile) => {
                                            return vendibile.MODELLO == data.MODELLO && vendibile.modello_var == data.modello_var;
                                        });


                                        console.info('c length', c.length);


                                        console.info('c', c);


                                    } catch (error) {
                                        console.info('error', error);
                                    }










                                    // location.reload();
                                }
                            }
                        }
                    } catch (e) {
                        console.info(e);
                    }
                    id_prodotto = c[0].id_prodotto;

                    // prendo il colore vetro da 
                    try {
                        let p = store.products.SORGENTE[0];
                        console.info('prenodo il colroe da sorgente', p);
                        let k = c.filter((prodotto) => {
                            return prodotto.COLOREVETRO == p.COLOREVETRO;
                        });
                        if (k.length > 0) {

                            console.info('ho trovato il prodotto !', k);
                            // cerco la montatura che mi serve se la 

                            id_prodotto = k[0].id_prodotto;

                            if (k[0].FAMIG_ESTESA == 'MINIGIOGALI') {
                                console.info('montatura', product.MONTATURA);
                                let k = c.filter((prodotto) => {
                                    return prodotto.testo_finiturastruttura == product.MONTATURA;
                                });
                                id_prodotto = k[0].id_prodotto;
                            }
                        }
                    } catch (error) {
                        console.info('errore...');
                    }

                } else if (c.length == 0) {
                    c = f.select_by_key_value_one_array(a, 'COLOREVETRO', product.VETRO);
                    let r = f.select_by_key_value_one_array(c, 'MODELLO', product.MODELLO);
                    if (r.length == 0) {
                        if (store.product_store.CODICE_UNIVOCO != '') {
                            id_prodotto = store.product_store.CODICE_UNIVOCO;
                        } else {
                            id_prodotto = product.CODICE_UNIVOCO;
                        }
                    } else {
                        id_prodotto = r[0].id_prodotto;
                    }
                }
                store.product_store.CODICE_UNIVOCO_CLICK_MODELLI = id_prodotto;
            } catch (error) {
                console.info(error, 'store serch id product by modello var');
            }
        },

        click_on_vetro: (store, vetro) => {
            let paese = store.product_store.PAESE;
            let montatura = store.product_store.MONTATURA;
            let vetro_selected = vetro;
            console.info('click on vetro', paese, montatura, vetro_selected, store);
            let product_list_details = store.products_store.DETAILS;
            console.info('click on vetro', product_list_details);
            let product_list_filterd = product_list_details.filter((prodotto) => {
                return prodotto.testo_finiturastruttura == montatura && prodotto.PAESE == paese && prodotto.COLOREVETRO == vetro_selected;
            });
            try {
                if (product_list_filterd.length == 0) {
                    product_list_filterd = product_list_details.filter((prodotto) => {
                        return prodotto.PAESE == paese && prodotto.COLOREVETRO == vetro_selected;
                    });
                }
            } catch (error) {
                console.info(error, 'error 1207');
            }




            let f = new filter_array();
            // let product_list = f.key_value(
            //     store.products_store.DETAILS, 
            //     'COLOREVETRO',             
            //     vetro);

            let modelli = f.group_by_modello_e_modello_var(
                product_list_filterd,
                store.products_store.MODELLO_VAR,
                store.products_store.MODELLO);
            if (f.search_id_product_exist(
                store.products_store.PRODOTTI_VENDIBILI,
                vetro,
                store.product_store.MONTATURA,
                store.product_store.SORGENTE,
                store.product_store.MODELLO_VAR
            )) {
                store.products.SORGENTE = modelli;
                store.product_store.VETRO = vetro;
            } else {
                try {
                    if (!f.key_value_exist(modelli, 'modello_var', store.product_store.MODELLO_VAR)) {
                        store.product_store.MODELLO_VAR = modelli[0].modello_var;
                    }
                } catch (error) {
                    store.product_store.MODELLO_VAR = 0;
                    console.info(error, 'error 1210');
                }

                if (f.search_id_product_exist(
                    store.products_store.PRODOTTI_VENDIBILI,
                    vetro,
                    store.product_store.MONTATURA,
                    store.product_store.SORGENTE,
                    store.product_store.MODELLO_VAR
                )) {
                    store.products.SORGENTE = modelli;
                    store.product_store.VETRO = vetro;
                } else {
                    // prova a cambiare finitura struttura e vedi se esiste 
                    // togli dall'array finitura struttura l'attuale
                    // per ogni variazione restante cerca id prodotto 
                    // fermati se la trovi
                    let fin_strutture = store.products_store.FINITURASTRUTTURA;
                    if (fin_strutture.length > 0) {
                        try {
                            fin_strutture.forEach(fin_struttura => {
                                if (f.search_id_product_exist(
                                    store.products_store.PRODOTTI_VENDIBILI,
                                    vetro,
                                    fin_struttura,
                                    store.product_store.SORGENTE,
                                    store.product_store.MODELLO_VAR
                                )) {
                                    store.products.SORGENTE = modelli;
                                    store.product_store.MONTATURA = fin_struttura;
                                    store.product_store.VETRO = vetro;
                                }
                            });
                        } catch (error) {
                            console.info(error);
                        }
                    }

                }

            }
            // QUI DEVO CONTROLLARE IL MODELLO VAR 
            // SE SORGENTE NON HA MODELLO VAR ALLORA MODELLO VAR CAMBIA SU PRODUCT STORE
            // VA MESSO UN ALERT? 
            // SE SORGENTE HA MODELLO VAR ALLORA MODELLO VAR CAMBIA SU PRODUCT STORE
            // SE SORGENTE HA MODELLO VAR ALLORA MODELLO VAR CAMBIA SU PRODUCT STORE
        },
        click_on_montatura_bis: (store) => {
            let montatura = store.products_store.MONTATURASET;
            let f = new filter_array();
            // prendo tutti i modelli di quella montatura
            let product_list = f.key_value(
                store.products_store.DETAILS,
                'testo_finiturastruttura',
                montatura);
            // di tutti i modelli con quella finitura struttura
            // prendo i modelli dalla lista dei modelli 
            // es MODELLO_VAR : [G:M:P]
            let modelli = f.group_by_modello_e_modello_var(
                product_list,
                store.products_store.MODELLO_VAR,
                store.products_store.MODELLO);
            // qui prima di cambiare questi devo controllare se ci sono 
            // codici univoci con quelle caraterristiche 
            if (f.search_id_product_exist(
                store.products_store.PRODOTTI_VENDIBILI,
                store.product_store.VETRO,
                montatura,
                store.product_store.SORGENTE,
                store.product_store.MODELLO_VAR
            )) {
                store.products.SORGENTE = modelli;
                store.product_store.MONTATURA = montatura;
            } else {

                // prova a cambiare modello e vedi se esiste un codice univoco
                if (!f.key_value_exist(modelli, 'modello_var', store.product_store.MODELLO_VAR)) {
                    store.product_store.MODELLO_VAR = modelli[0].modello_var;
                }
                if (f.search_id_product_exist(
                    store.products_store.PRODOTTI_VENDIBILI,
                    store.product_store.VETRO,
                    montatura,
                    store.product_store.SORGENTE,
                    store.product_store.MODELLO_VAR
                )) {
                    store.products.SORGENTE = modelli;
                    store.product_store.MONTATURA = montatura;
                } else {
                    // prova a cambiare finitura struttura e vedi se esiste 
                    // togli dall'array finitura struttura l'attuale
                    // per ogni variazione restante cerca id prodotto 
                    // fermati se la trovi
                    // per ogni vetro controlla se esiste il prodotto altrimenti errore 
                    let vetri = store.products_store.COLOREVETRO;
                    if (vetri.length > 0) {
                        try {
                            vetri.forEach(vetro => {
                                // cerco se il prodotto esiste se il prodotto esiste break del foreach 
                                if (f.search_id_product_exist(
                                    store.products_store.PRODOTTI_VENDIBILI,
                                    vetro,
                                    montatura,
                                    store.product_store.SORGENTE,
                                    store.product_store.MODELLO_VAR
                                )) {
                                    store.products.SORGENTE = modelli;
                                    store.product_store.MONTATURA = montatura;
                                    store.product_store.VETRO = vetro;
                                }
                            });
                        } catch (error) {
                            console.info(error);
                        }
                    }

                }

            }
            // QUI DEVO CONTROLLARE IL MODELLO VAR 
            // SE SORGENTE NON HA MODELLO VAR ALLORA MODELLO VAR CAMBIA SU PRODUCT STORE
            // VA MESSO UN ALERT? 
            // SE SORGENTE HA MODELLO VAR ALLORA MODELLO VAR CAMBIA SU PRODUCT STORE
            // SE SORGENTE HA MODELLO VAR ALLORA MODELLO VAR CAMBIA SU PRODUCT STORE
        },
        add_codice_alt_hystory: (store, data) => {
            console.info('cod alt', data, store);
            store.codalt_hystory.push(data);
        },
        click_on_montatura_lio: (store, montatura) => {
            let paese = store.product_store.PAESE;
            let vetri = store.product.vetri_new;
            let vetro_selected = store.product_store.VETRO;

            console.info('click on montatura', paese, montatura, vetro_selected, store, vetri);
            let f = new filter_array();
            //let product_list = f.key_value(
            //     store.products_store.DETAILS, 
            //    'testo_finiturastruttura',             
            //    montatura);

            let product_list_details = store.products_store.DETAILS;
            console.info('click on montatura', product_list_details);
            let product_list_filterd = product_list_details.filter((prodotto) => {
                return prodotto.testo_finiturastruttura == montatura && prodotto.PAESE == paese && prodotto.COLOREVETRO == vetro_selected;
            });


            console.info('click on montatura', product_list_details, product_list_filterd);
            // di tutti i modelli con quella finitura struttura
            // prendo i modelli dalla lista dei modelli 
            // es MODELLO_VAR : [G:M:P]
            let modelli = f.group_by_modello_e_modello_var(
                product_list_filterd,
                store.products_store.MODELLO_VAR,
                store.products_store.MODELLO);

            console.info('click on montatura', modelli);

            // qui prima di cambiare questi devo controllare se ci sono 
            // codici univoci con quelle caraterristiche 
            console.info('click on montatura', 'esiste');
            store.products.SORGENTE = modelli;
            store.product_store.MONTATURA = montatura;

        },
        click_on_montatura: (store, montatura) => {
            /* se tutto va bene click on montatura setta queste due variabili dello store
            store.products.SORGENTE = modelli;
            store.product_store.MONTATURA = montatura;
            */

            /* in alcuni casi questo non va bene quindi devo cambiare qualco'altro */

            let paese = store.product_store.PAESE;
            let vetri = store.product.vetri_new;
            let vetro_selected = store.product_store.VETRO;
            console.info('click on montatura', paese, montatura, vetro_selected, store, vetri);
            let f = new filter_array();
            let product_list_details = store.products_store.DETAILS;
            console.info('click on montatura', product_list_details);
            let product_list_filterd = product_list_details.filter((prodotto) => {
                return prodotto.testo_finiturastruttura == montatura && prodotto.PAESE == paese && prodotto.COLOREVETRO == vetro_selected;
            });
            try {
                console.info('A');
                if (product_list_filterd.length == 0) {
                    console.info('B');
                    product_list_filterd = product_list_details.filter((prodotto) => {
                        return prodotto.testo_finiturastruttura == montatura && prodotto.PAESE == paese;
                    });
                }
            } catch (error) {
                console.info('error 1426')
            }
            console.info('click on montatura', product_list_details, product_list_filterd);
            // di tutti i modelli con quella finitura struttura
            // prendo i modelli dalla lista dei modelli 
            // es MODELLO_VAR : [G:M:P]
            let modelli = f.group_by_modello_e_modello_var(
                product_list_filterd,
                store.products_store.MODELLO_VAR,
                store.products_store.MODELLO);
            console.info('click on montatura modelli:', modelli);
            // qui prima di cambiare questi devo controllare se ci sono 
            // codici univoci con quelle caraterristiche 
            let sie = f.search_id_product_exist(
                store.products_store.PRODOTTI_VENDIBILI,
                store.product_store.VETRO,
                montatura,
                store.product_store.SORGENTE,
                store.product_store.MODELLO_VAR)
            if (sie) {
                /* qui è andato tutto bene */
                console.info('C');
                console.info('click on montatura', 'esiste');
                store.products.SORGENTE = modelli;
                store.product_store.MONTATURA = montatura;
            } else {
                /* qui no ! */
                console.info('D');
                console.info('click on montatura', 'non esiste');
                // prova a cambiare modello e vedi se esiste un codice univoco


                if (!f.key_value_exist(modelli, 'modello_var', store.product_store.MODELLO_VAR)) {
                    store.product_store.MODELLO_VAR = modelli[0].modello_var;
                    console.info('E');
                }
                if (f.search_id_product_exist(
                    store.products_store.PRODOTTI_VENDIBILI,
                    store.product_store.VETRO,
                    montatura,
                    store.product_store.SORGENTE,
                    store.product_store.MODELLO_VAR
                )) {
                    console.info('F');
                    store.products.SORGENTE = modelli;
                    store.product_store.MONTATURA = montatura;
                } else {
                    // prova a cambiare finitura struttura e vedi se esiste 
                    // togli dall'array finitura struttura l'attuale
                    // per ogni variazione restante cerca id prodotto 
                    // fermati se la trovi
                    // per ogni vetro controlla se esiste il prodotto altrimenti errore 
                    console.info('G');
                    let vetri = store.products_store.COLOREVETRO;
                    if (vetri.length > 0) {
                        console.info('H');
                        try {
                            vetri.forEach(vetro => {
                                // cerco se il prodotto esiste se il prodotto esiste break del foreach 
                                if (f.search_id_product_exist(
                                    store.products_store.PRODOTTI_VENDIBILI,
                                    vetro,
                                    montatura,
                                    store.product_store.SORGENTE,
                                    store.product_store.MODELLO_VAR
                                )) {
                                    console.info('I');
                                    store.products.SORGENTE = modelli;
                                    store.product_store.MONTATURA = montatura;
                                    store.product_store.VETRO = vetro;
                                } else {
                                    console.info('L');
                                    let PV = store.products_store.PRODOTTI_VENDIBILI;
                                    let V = store.product_store.VETRO;
                                    let M = montatura;
                                    let S = store.product_store.SORGENTE;
                                    let MV = store.product_store.MODELLO;
                                    let f = PV.filter((prodotto) => {
                                        return prodotto.COLOREVETRO === V;
                                    })
                                    let f1 = f.filter((prodotto) => {
                                        return prodotto.testo_finiturastruttura === M;
                                    })
                                    let f2 = f1.filter((prodotto) => {
                                        return prodotto.MODELLO === MV;
                                    })
                                    let f3 = f2.filter((prodotto) => {
                                        return prodotto.SORGENTE === S;
                                    })
                                    console.info('f3', S, f3);
                                    try {
                                        if (f3.length > 0) {
                                            console.info('M');
                                            store.products.SORGENTE = modelli;
                                            store.product_store.MONTATURA = montatura;
                                        } else {
                                            console.info('N');
                                            if (f2.length > 0) {
                                                console.info('O');
                                                f3 = f2.filter((prodotto) => {
                                                    return prodotto.SORGENTE === f2[0].SORGENTE;
                                                })
                                                if (f3.length > 0) {
                                                    console.info('P');
                                                    store.products.SORGENTE = modelli;
                                                    store.product_store.MONTATURA = montatura;
                                                    store.product_store.SORGENTE = f2[0].SORGENTE;
                                                }
                                            }
                                        }
                                    } catch (error) {
                                        console.info('error', error);
                                    }
                                    if (modelli[0].famiglia == 'LUCCI') {
                                        console.info('Q');
                                        let filter_arr = new filter_array();
                                        let m = filter_arr.get_modelli_a(modelli);
                                        store.product_store.SORGENTE = m[0];
                                        store.products.SORGENTE = modelli;
                                        store.product_store.MONTATURA = montatura;
                                        store.product_store.VETRO = vetro;
                                    }
                                    if (modelli[0].famiglia == 'MODUL') {
                                        console.info('Q');
                                        let filter_arr = new filter_array();
                                        let m = filter_arr.get_modelli_a(modelli);
                                        store.product_store.SORGENTE = m[0];
                                        store.products.SORGENTE = modelli;
                                        store.product_store.MONTATURA = montatura;
                                        store.product_store.VETRO = vetro;
                                    }
                                    if (modelli[0].famiglia == 'ARMON') {
                                        console.info('Q');
                                        let filter_arr = new filter_array();
                                        // MI CERCO TUTTE LE SORGENTI LUMINOSE
                                        let m = filter_arr.get_modelli_a(modelli);
                                        // DEFINISCO (IMPONGO QUESTA SORGENTE LUMINOSA COME SCELTA)
                                        store.product_store.SORGENTE = m[0];
                                        store.products.SORGENTE = modelli;
                                        store.product_store.MONTATURA = montatura;
                                        store.product_store.VETRO = vetro;
                                    }
                                    if (modelli[0].famiglia == 'ORO') {
                                        console.info('Q');
                                        let filter_arr = new filter_array();
                                        // MI CERCO TUTTE LE SORGENTI LUMINOSE
                                        let m = filter_arr.get_modelli_a(modelli);
                                        // DEFINISCO (IMPONGO QUESTA SORGENTE LUMINOSA COME SCELTA)
                                        store.product_store.SORGENTE = m[0];
                                        store.products.SORGENTE = modelli;
                                        store.product_store.MONTATURA = montatura;
                                        store.product_store.VETRO = vetro;
                                    }
                                    if (modelli[0].famiglia == 'LUCCI' && modelli[0].tipologia == 'LT') {
                                        let filter_arr = new filter_array();
                                        let product_list_details_a = store.products_store.DETAILS;
                                        let product_list_filterd = product_list_details_a.filter((prodotto) => {
                                            return prodotto.testo_finiturastruttura == montatura && prodotto.PAESE == paese;
                                        });


                                        console.table(product_list_details_a);
                                        console.info('*******filtrati********')
                                        console.table(product_list_filterd);
                                        console.info('*******filtrati********')
                                        let m = filter_arr.get_modelli_a(product_list_details_a);
                                        store.product_store.SORGENTE = m[0];
                                        store.products.SORGENTE = product_list_filterd;
                                        store.product_store.MONTATURA = montatura;
                                        store.product_store.VETRO = vetro;
                                    }
                                }



                            });
                        } catch (error) {
                            console.info(error);
                        }
                    }

                }

            }

            // QUI DEVO CONTROLLARE IL MODELLO VAR 
            // SE SORGENTE NON HA MODELLO VAR ALLORA MODELLO VAR CAMBIA SU PRODUCT STORE
            // VA MESSO UN ALERT? 
            // SE SORGENTE HA MODELLO VAR ALLORA MODELLO VAR CAMBIA SU PRODUCT STORE
            // SE SORGENTE HA MODELLO VAR ALLORA MODELLO VAR CAMBIA SU PRODUCT STORE

        },
        click_on_modello: (store, data) => {
            store.product_store.MODELLO_VAR = data.modello_var;
        },
        aggiorna_sorgente_luminosa: (store) => {
            let s = new sorgenti_s();
            let mv = store.product_store.MODELLO_VAR;
            let m = store.product_store.VETRO;
            let pa = store.product_store.PAESE;
            let fs = store.product_store.MONTATURA;
            let prods = store.products_store.PRODOTTI_VENDIBILI;
            /* try {
                
         
            console.info('mutation aggiorna sorgente luminosa', store.products.SORGENTI);
            // ogni sorgente che rappresenta l'elenco dei modelli nella pagina prodotto

            let sorgenti = store.products.SORGENTE;
            let sorgente_selected = '';
            let sorgente_selected_arr = '';
        
            sorgenti.forEach(element => {
                if (element.SELECTED){
                    sorgente_selected = element.test_led;
                    sorgente_selected_arr = element;

                }
            });
            // se non ne trovo seleted allora setto il primo elemento

            if (sorgente_selected == ''){
                sorgente_selected = sorgenti[0].test_led;
            }
            let sorgenti_tipi = [];
            let sorgenti_ar = [];

            sorgenti.forEach(element => {
                
                if (                    !sorgenti_tipi.includes(element.test_led)    ){
                  sorgenti_tipi.push(element.test_led);
                  sorgenti_ar.push(element);
                }
                store.products_store.SORGENTE_LUMINOSA.LED = sorgente_selected_arr;
                store.products_store.SORGENTE_LUMINOSA.LEDS = sorgenti_ar;
                console.info(store.product_store.SORGENTE_LUMINOSA);

            });

            console.info('mutation aggiorna sorgente luminosa', 'selected:', sorgente_selected, 'sorgenti_tipi', sorgenti_tipi);

        } catch (error) {
            console.info('mutation aggiorna sorgente luminosa error', error);
        } */
            try {
                let p = prods.filter((prodotto) => {
                    return prodotto.PAESE == pa;
                });
                let p0 = p.filter((prodotto) => {
                    return prodotto.COLOREVETRO == m;
                });
                let p1 = p0.filter((prodotto) => {
                    return prodotto.testo_finiturastruttura == fs
                });
                let p2 = p1.filter((prodotto) => {
                    return prodotto.modello_var == mv
                });
                let s1 = [];
                let s2 = [];
                if (p2.length > 0) {
                    try {
                        p2.forEach(element => {
                            if (!s2.includes(element.SORGENTE)) {
                                s2.push(element.SORGENTE);
                            }
                            s1.push(element);
                        });
                        store.products_store.SORGENTE_PRODUCTS = s1;
                        console.info('raggruppo 4', store.products_store.SORGENTE_PRODUCTS);
                        // se il prodotto è riflesso
                        if (store.products_store.SORGENTE_PRODUCTS[0].famiglia == 'RIFLE') {
                            // DEVI FILTRARE PER MODELLO TUTTI I PRODOTTI 
                            let modello_del_primo_elemento = store.products_store.SORGENTE_PRODUCTS[0].MODELLO;
                            console.info('raggruppo 4 modello', modello_del_primo_elemento)
                            store.products_store.SORGENTE_PRODUCTS = store.products_store.SORGENTE_PRODUCTS.filter((prodotto) => {
                                return prodotto.MODELLO == modello_del_primo_elemento;
                            });
                            console.info('raggruppo 4 modelli filtrati', store.products_store.SORGENTE_PRODUCTS);


                        }
                        store.products_store.SORGENTE_PRODUCT = s1[0];
                        console.info('BEFORE sorgente:', store.products_store.SORGENTE);

                        store.products_store.SORGENTE = s2;
                        console.info('AFTER sorgente:', store.products_store.SORGENTE);

                        console.info('mutation aggiorna sorgente s2', s2);
                    } catch (error) {
                        console.info(error);
                    }
                }
            } catch (error) {
                store.products_store.SORGENTE_PRODUCTS = s.ottieni_sorgenti(mv, m, fs, prods);
                console.info('raggruppo 5', store.product_store.SORGENTE_PRODUCTS);
                store.products_store.SORGENTE_PRODUCT = store.products_store.SORGENTE_PRODUCTS[0];
                console.info('BEFORE sorgente:', store.products_store.SORGENTE);

                store.products_store.SORGENTE = s.ottieni_sorgenti_list(store.products_store.SORGENTE_PRODUCTS);
                console.info('AFTER sorgente:', store.products_store.SORGENTE);

                console.info(error);
            }
        },
        aggiorna_s(store, data) {
            store.product_store.SORGENTEBIS = data;
        },

        set_ordinando: (store, ordinando) => {
            store.product_store.ORDINANDO = ordinando;
        },
        set_flashing: (store, flashing) => {
            store.product_store.FLASHING = flashing;
        },

        vetro_selected: (store, state) => {
            // questa mutation imposta a true o a false state vetri
            store.product.vetri = state.vetri;
            store.product.vetro = state.vetro;
            for (let index = 0; index < state.vetri.length; index++) {
                if (state.vetri[index].COLOREVETRO == state.vetro) {
                    state.vetri[index].SELECTED = true;
                } else {
                    state.vetri[index].SELECTED = false;
                }
            }
        },
        finiture_selected: (store, state) => {
            store.product.finiture = state.finiture;
            store.product.finiture_list = state.finiture_list;
            for (let index = 0; index < state.finiture_list.length; index++) {
                if (state.finiture_list[index].FINITURASTRUTTURA == state.finiture) {
                    state.finiture_list[index].SELECTED = true;
                } else {
                    state.finiture_list[index].SELECTED = false;
                }
            }
        },

        led_selected: (store, data) => {
            store.product.led = data.led;
        },

        leds_selected: (store, data) => {
            store.product.leds = data.leds;
        },

        add_sorgenti_estese: (store, data) => {
            store.products.sorgenti_estese = data.ce;
            store.products.sorgenti_estese_ul = data.ul;
        },

        filter_product_for_paese: (store, data) => {
            let that = data;
            store.products.ALL = data.products;
            store.products[data.PAESE] = data.products.filter(function (product) {
                return product.PAESE == that.PAESE;
            });
        },
        filter_product_for_vetro: (store) => {
            let that = store;
            store.products['VETRO'] = store.products[store.product.paese].filter(function (product) {
                return product.COLOREVETRO == that.product.vetro;
            });
        },
        // questo filtro filtra i prodotti presenti nello store 
        // li filtra per vetro selected
        filter_product_for_finiture: (store) => {
            let that = store;
            store.products['FINITURE'] = store.products.VETRO.filter(function (product) {
                return product.testo_finiturastruttura == that.product.finiture;
            });
        },

        filter_product_for_led: (store) => {
            let that = store;
            let filter = store.products.FINITURE.filter(function (product) {
                return product.SORGENTE == that.product.led;
            });
            // ordino i prootti in modo che il rpimo sia selezionato
            for (let index = 0; index < filter.length; index++) {
                if (index == 0) {
                    filter[index].SELECTED = true;
                } else {
                    filter[index].SELECTED = false;
                }
            }
            store.products['SORGENTE'] = filter;
            // qui ci vado se il filtro ha avuto risultato zero
            // quindi devo cambiare finitura 
        },

        product_selected: (store) => {
            let product_id;
            product_id = store.products.SORGENTE.filter(function (product) {
                return product.SELECTED == true;
            });
            try {
                store.product.id = product_id[0].id_prodotto;
                store.product.quantita.DATA = product_id[0].DATA;
                store.product.quantita.DISPONIBILE = product_id[0].DISPONIBILE;
                store.product.quantita.FATTIBILE = product_id[0].FATTIBILE;
            } catch (error) {
                store.product.id = '';
                store.product.quantita.DATA = '';
                store.product.quantita.DISPONIBILE = '';
                store.product.quantita.FATTIBILE = '';
                // on error secondo me non devo settare tutto nullo ...
            }
        },
        mutate_list_products: (store, data) => {
            store.listacontuttelesorgenti = data.listasorgenti;
        },
        mutate_count_product: (store, data) => {
            store.quantita = data.quantita;
        },
        add_prezzi: (store, data) => {
            store.products.prezzi = data.prezzi
        },
        filter_prezzo: (state) => {
            let id = state.product.id;
            let prezzo = state.products.prezzi.filter(function (product) {
                return product.CODICE_UNIVOCO == id;
            });
            let prezzo_a = prezzo.filter(function (prezzi) {
                return prezzi.Codice_listino == state.product.codice_listino;
            });
            if ('0' in prezzo_a) {
                if ('Prezzo_di_vendita' in prezzo_a[0]) {
                    state.product.prezzo = prezzo_a[0].Prezzo_di_vendita;
                } else {
                    state.product.prezzo = 0;
                }
            } else {
                state.product.prezzo = 0;

            }
        },
        add_codice_listino: (store, data) => {
            console.info('mutation add_codice_listino data:', data);
            store.product['codice_listino'] = data.codice_listino;
        },
        sorgente_selected_store: (store, data) => {
            store.modello_selected.SORGENTE = data.sorgente;
        },
        finitura_selected_store: (store, data) => {
            store.modello_selected.MONTATURA = data.finitura;
        },
        vetro_selected_store: (store, data) => {
            store.modello_selected.VETRO = data.vetro;
        },
        modello_selected: (store, data) => {
            store.modello_selected.MODELLO = data.modello;
        },
        change_language: (store, data) => {
            store.product.language = data.language;
        },
        change_language_download: (store) => {
            store.items.item1[0].title = 'Assembly sheet';
            store.items.item2[0].title = 'Collection sheet';
            store.items.item3[0].title = 'Product sheet';
            store.items.item4[0].title = '2D Model';
            store.items.item5[0].title = '3D Model';
            store.items.item6[0].title = 'Texture library';
            store.items.item7[0].title = 'Certifications';
        },
        change_url: (store, data) => {
            store.status.url = data.url;
        },
        show_product_id: (store, data) => {
            store.product.showid = data.id
        },
        change_status: (store, data) => {
            store.status.status = data.status
        },
        product_wid: (store, data) => {
            let l = new is_localhost();
            console.log = function () { }
            if (!l.is_localhost() && window.location.hostname != 'webvistosi.wowtest.it') {
                // console.log = function() {}
                // console.info = function() {} 
                // console.table= function() {}
            }
            store.product.wid = data.wid
        },
        set_prezzo: (store, data) => {
            store.product.prezzo = data.prezzo
            store.product.quantity = data.quantity
        },

        debug: (store) => {
            if (store.products.debug) {
                store.products.debug = false;
            } else {
                store.products.debug = true;
            }
        },
        get_documents: (store) => {
            try {
                let i = new getDocument();
                let document = i.getDocumentbyID(store);
                document = '';
                this.do = document;
            } catch (error) {
                console.log('documenti non trovati');
            }
        },
        new_product_link_search: (store) => {
            /* */ console.log("get documents", store);
            try {
                let i = new new_product_link_search();

                i.show_new_on_product(store);


            } catch (error) {
                /* */ console.log('documenti non trovati');
            }

        },
        get_codicealtatt: (store) => {
            try {
                let i = new getDocument();
                let document = i.getCodAlt(store);
                document = '';
                this.do = document;
            } catch (error) {
                console.log('documenti non trovati');
            }

        },
        add_codice_alt: (store, codalt) => {
            store.codalt = codalt;
        },
        filter_paese: (store, data) => {
            store.list_product_ce = data.list_product_paese
        },
        set_products_selected: (store, data) => {
            store.products[data.type] = data.products;
            let s = data.products.filter((p) => {
                return p.SELECTED == true;
            })
            try {
                store.product.id = s[0].id_prodotto;
            } catch (error) {
                console.info(error);
            }
        },
        change_finitura: (store) => {
            // questa funzione deve prendere l'array delle finiture 
            // nel componente questo array è in data finitura struttura 
            // nello state sara data.product.finiure
            // lo setto al created quando setto vetri 
            // trovo index dell'attuale fnitura
            // index fnitura 
            // parto dalla lista filtrata per paese
            let i = 0;
            let e = false;
            let product_paese = store.products[store.product.paese];
            try {

                for (let index = 0; index < product_paese.length; index++) {
                    if (product_paese[index].COLOREVETRO == store.product.vetro && i == 0) {
                        e = product_paese[index].testo_finiturastruttura;
                        i = 1;
                    }
                }

            } catch (error) {
                console.info(error);
            }
            store.product.finiture = e;
            // adesso devo aggiornare product.finiture_list
            try {

                for (let index = 0; index < store.product.finiture_list.length; index++) {
                    //  const element = array[index];
                    if (store.product.finiture_list[index].FINITURASTRUTTURA == e) {
                        store.product.finiture_list[index].SELECTED = true;
                    } else {
                        store.product.finiture_list[index].SELECTED = false;
                    }
                }
            } catch (error) {
                console.info(error);
            }

        },
        aggiornare_sorgente: (store, data) => {
            store.product_store.SORGENTE = data;
            store.product_store.SORGENTEBIS = data;
        },
        change_id_prodotto: (store, data) => {
            store.product_store.CODICE_UNIVOCO = data.id_prodotto;
            store.product_store.SORGENTEBIS = data.sorgente;
            store.product_store.CODICE_UNIVOCO_CLICK_MODELLI = data.id_prodotto;
        },
        modello_click: (store, data) => {
            let product = [];
            for (let index = 0; index < store.products.SORGENTE.length; index++) {
                if (store.products.SORGENTE[index].id_prodotto == data.id_prodotto) {
                    store.products.SORGENTE[index].SELECTED = true;
                    store.product.modello_var = store.products.SORGENTE[index].modello_var;
                    product = store.products.SORGENTE[index];
                    store.product.id = store.products.SORGENTE[index].id_prodotto;
                } else {
                    store.products.SORGENTE[index].SELECTED = false;
                }
                // aggiorno product id 
                store.product.id_product = data.id_prodotto;
            }
            // aggiorno immagine ... 
            let img = new change_img();
            img.change_img(product.img_left, store);
        },
        vetro_click: (store, data) => {
            let product_ = [];
            try {
                for (let index = 0; index < store.product.vetri.length; index++) {
                    if (store.product.vetri[index].COLOREVETRO == data.COLOREVETRO) {
                        store.product.vetri[index].SELECTED = true;
                        product_ = store.product.vetri[index];
                    } else {
                        store.product.vetri[index].SELECTED = false;
                    }
                }
            } catch (error) {
                console.info(error);
            }

            // aggiorno product id 
            store.product.vetro = product_.COLOREVETRO;
            let colorevetro = data.COLOREVETRO;
            // filtra i prodotti che hanno quel vetro 
            store.products.FINITURE = store.products[store.product.paese].filter(
                function (product) {
                    return product.COLOREVETRO == colorevetro;
                }
            )
            let sorgente = store.product.led;
            store.products.SORGENTE = store.products.FINITURE.filter(
                function (product) {
                    return product.SORGENTE == sorgente
                }
            );
            let montatura_vetro_selected = '';
            let modello_var = store.product.modello_var;
            let modello_var_exist = false;
            try {
                for (let index = 0; index < store.products.SORGENTE.length; index++) {
                    if (modello_var.length > 0) {

                        if (store.products.SORGENTE[index].modello_var == modello_var) {
                            store.products.SORGENTE[index].SELECTED = true;
                            modello_var_exist = true;

                        }

                    }

                }
            } catch (error) {
                console.info(error);
            }

            //    linkspecifici,
            //    linkspecifici_obj,
            //    linkmuseo,
            let index_link = 1;
            let occhio_ind = '<div id="occhio-centrato" class="occhio-centrato 4"> <a href="https://vistosi.it/vistosivirtualmuseum/index.htm?media-index=' + index_link + '/">  <input type="image" style="padding:0px"; src="https://vistosi.it/wp-content/uploads/2021/09/OCCHIO.svg" /> <h6 style="color:#686868; max-width:100px; text-align: center">Vedi nel museo </h6> </a> </div> '
            store.occhio.occhio = occhio_ind;
            try {
                for (let index = 0; index < store.products.SORGENTE.length; index++) {

                    if (index == 0) {
                        if (!modello_var_exist) {
                            store.products.SORGENTE[index].SELECTED = true;
                            // aggiorno immagine ... 
                            store.product.id = store.products.SORGENTE[index].id_prodotto;
                            montatura_vetro_selected = store.products.SORGENTE[index].testo_finiturastruttura;
                            store.product.finiture = store.products.SORGENTE[index].testo_finiturastruttura;
                            store.product.vetro = store.products.SORGENTE[index].COLOREVETRO;
                            let el = document.getElementById("img-splash").querySelectorAll("img");
                            el[0].setAttribute("src", store.products.SORGENTE[index].img_left);

                            // TO REMOVE PREVIOUS ELEMENT
                            var insertedContent = document.querySelector(".occhio-centrato");
                            if (insertedContent) {
                                insertedContent.parentNode.removeChild(insertedContent);
                            }
                            el[0].insertAdjacentHTML('afterend', occhio_ind);

                        } else {
                            store.products.SORGENTE[index].SELECTED = false;
                        }



                    } else if (store.products.SORGENTE[index].modello_var == modello_var && modello_var_exist) {
                        store.products.SORGENTE[index].SELECTED = true;
                        // aggiorno immagine ... 
                        store.product.id = store.products.SORGENTE[index].id_prodotto;
                        montatura_vetro_selected = store.products.SORGENTE[index].testo_finiturastruttura;
                        store.product.finiture = store.products.SORGENTE[index].testo_finiturastruttura;
                        store.product.vetro = store.products.SORGENTE[index].COLOREVETRO;
                        let el = document.getElementById("img-splash").querySelectorAll("img");
                        el[0].setAttribute("src", store.products.SORGENTE[index].img_left);

                        // TO REMOVE PREVIOUS ELEMENT
                        insertedContent = document.querySelector(".occhio-centrato");
                        modello_var_exist = false;
                        if (insertedContent) {
                            insertedContent.parentNode.removeChild(insertedContent);
                        }

                        el[0].insertAdjacentHTML('afterend', occhio_ind);

                    }


                    else {
                        store.products.SORGENTE[index].SELECTED = false;
                    }
                }
            } catch (error) {
                console.info(error);
            }

            //   store.product.vetro = data.COLOREVETRO;
            try {
                for (let index = 0; index < store.product.finiture_list.length; index++) {

                    if (store.product.finiture_list[index].FINITURASTRUTTURA == montatura_vetro_selected) {
                        store.product.finiture_list[index].SELECTED = true;

                    } else {
                        store.product.finiture_list[index].SELECTED = false;
                    }

                }

            } catch (error) {
                console.info(error);
            }

        },
        montatura_click: (store, data) => {
            // seleziono la montatura cliccata
            try {
                for (let index = 0; index < store.product.finiture_list.length; index++) {
                    if (store.product.finiture_list[index].FINITURASTRUTTURA ==
                        data.MONTATURA) {
                        store.product.finiture_list[index].SELECTED = true;

                    } else {
                        store.product.finiture_list[index].SELECTED = false;
                    }
                }
            } catch (error) {
                console.info(error);
            }


            let montatura = data.MONTATURA;
            store.products.FINITURE = store.products[store.product.paese].filter(
                function (product) {
                    return product.testo_finiturastruttura == montatura;
                }
            )
            let sorgente = store.product.led;
            store.products.SORGENTE = store.products.FINITURE.filter(
                function (product) {
                    return product.SORGENTE == sorgente
                }
            );
            let index_link = 1;
            let occhio_ind = '<div id="occhio-centrato" class="occhio-centrato 2"> <a href="https://vistosi.it/vistosivirtualmuseum/index.htm?media-index=' + index_link + '/">  <input type="image" style="padding:0px"; src="https://vistosi.it/wp-content/uploads/2021/09/OCCHIO.svg" /> <h6 style="color:#686868; max-width:100px; text-align: center">Vedi nel museo </h6> </a> </div> '
            store.occhio.occhio = occhio_ind;
            let vetro = '';
            try {
                for (let index = 0; index < store.products.SORGENTE.length; index++) {
                    if (index == 0) {
                        store.products.SORGENTE[index].SELECTED = true;
                        vetro = store.products.SORGENTE[index].COLOREVETRO;
                        // CHANGE IMAGE 
                        store.product.id = store.products.SORGENTE[index].id_prodotto;
                        store.product.vetro = vetro;
                        let el = document.getElementById("img-splash").querySelectorAll("img");
                        el[0].setAttribute("src", store.products.SORGENTE[index].img_left);

                        // TO REMOVE PREVIOUS ELEMENT
                        var insertedContent = document.querySelector(".occhio-centrato");
                        if (insertedContent) {
                            insertedContent.parentNode.removeChild(insertedContent);
                        }

                        el[0].insertAdjacentHTML('afterend', occhio_ind);

                    } else {
                        store.products.SORGENTE[index].SELECTED = false;
                    }
                }
            } catch (error) {
                console.info(error);
            }
            try {

                for (let index = 0; index < store.product.vetri.length; index++) {
                    if (store.product.vetri[index].COLOREVETRO == vetro) {
                        store.product.vetri[index].SELECTED = true;
                    } else {
                        store.product.vetri[index].SELECTED = false;
                    }
                }
            } catch (error) {
                console.info(error);
            }

            // qui devo filtrare per vetro tanto se il vetro è già quello giusto non c'è problema no ?
            store.products.SORGENTE = store.products.SORGENTE.filter(
                function (product) {
                    return product.COLOREVETRO == vetro;
                }
            );
            // console.info('16',store.products.SORGENTE);

            // change montatura value on product?? ... 
            store.product.finiture = data.MONTATURA;

            // AGGIORNO I LED... 
            if (store.product.leds_old.length == 0) {
                store.product.leds_old = store.product.leds;
            }
            store.product.leds = [];

            var a = "";
            try {
                for (let index = 0; index < store.product.leds_old.length; index++) {
                    const ledArray = store.product.leds_old[index];

                    a = store.products.FINITURE.filter((item) => item.SORGENTE == ledArray.Codice);

                    if (a.length > 0) {
                        // INCOLLA NUOVAMENTE LED
                        store.product.leds.push(ledArray)
                    }
                    // ledArray.filter((item) => item.SORGENTE == "E27")
                }
            } catch (error) {
                console.info(error);
            }


        },
        led_click: (store, data) => {
            let led = data.led;

            let finiture = store.product.finiture;
            store.products.FINITURE = store.products[store.product.paese].filter(
                function (product) {
                    return product.testo_finiturastruttura == finiture;
                }
            )
            // adesso filtro finiture per tutti gli altri vetro 
            let vetro = store.product.vetro;
            store.products.VETRO = store.products.FINITURE.filter(
                function (product) {
                    return product.COLOREVETRO == vetro;
                }
            )

            store.products.SORGENTE = store.products.VETRO.filter(
                function (product) {
                    return product.SORGENTE == led;
                }
            )
            // selezina il primo dei product Sorgente
            for (let index = 0; index < store.products.SORGENTE.length; index++) {
                if (index == 0) {
                    store.products.SORGENTE[index].SELECTED = true;
                    store.product.id = store.products.SORGENTE[index].id_prodotto;
                    // cambia anche l'immagine del product 
                    let img = new change_img();
                    img.change_img(store.products.SORGENTE[index].img_left, store);
                } else {
                    store.products.SORGENTE[index].SELECTED = false;
                }
            }

        },

        change_vetro: (store) => {
            let i = 0;
            let e = false;
            let product_paese = store.products[store.product.paese];
            for (let index = 0; index < product_paese.length; index++) {
                if (product_paese[index].testo_finiturastruttura == store.product.finiture && i == 0) {
                    e = product_paese[index].COLOREVETRO;
                    i = 1;
                }
            }
            store.product.vetro = e;
            // adesso devo aggiornare product.finiture_list
            let o = 0;
            for (let index = 0; index < store.product.vetri.length; index++) {
                if (store.product.vetri[index].COLOREVETRO == e && o == 0) {
                    store.product.vetri[index].SELECTED = true;
                    o++;
                } else {
                    store.product.vetri[index].SELECTED = false;
                }
            }
        },

        click_certificazione: (store, data) => {
            if (data.paese == 'ce') {
                store.product.europe = true;
                store.product.usa = false;
                store.product.paese = 'CE';
                store.product.leds = store.products.sorgenti_estese.elettrificazioni;
                store.product.led = store.products.sorgenti_estese.model.Codice;
            } else {
                store.product.europe = false;
                store.product.usa = true;
                store.product.paese = 'UL';
                store.product.leds = store.products.sorgenti_estese_ul.elettrificazioni;
                store.product.led = store.products.sorgenti_estese_ul.model.Codice;
            }
            // creo i product UL 
            if (store.products.UL.length == 0) {
                store.products['UL'] = store.products.ALL.filter(function (product) {
                    return product.PAESE == 'UL';
                });
            }
            let that = store;
            store.products['VETRO'] = store.products[store.product.paese].filter(function (product) {
                return product.COLOREVETRO == that.product.vetro;
            });
            // FINITURE 
            store.products['FINITURE'] = store.products.VETRO.filter(function (product) {
                return product.testo_finiturastruttura == that.product.finiture;
            });
            store.products['SORGENTE'] = store.products.FINITURE.filter(function (product) {
                return product.SORGENTE == that.product.led;
            });
            try {
                for (let index = 0; index < store.products['SORGENTE'].length; index++) {
                    if (index == 0) {
                        store.products['SORGENTE'][index].SELECTED = true;
                        store.product.id = store.products['SORGENTE'][index].id_prodotto;
                    } else {
                        store.products['SORGENTE'][index].SELECTED = false;
                    }

                }
            } catch (error) {
                console.info(error);
            }
        },

        selected_paese: (store, paese) => {
            store.paese = paese;
            // DEVO AGGIORNARE LE SORGENTI LUMINOSE AL CAMBIO DI PAESE
        }

    }
})